import { apiClient } from '../../../api/client';
import { handleApiError } from '../../../api/errorHandler';

import { UpdateBalanceRequest, UpdateBalanceResponse } from './types';

export const updateBalance = async (
  params: UpdateBalanceRequest
): Promise<UpdateBalanceResponse> => {
  try {
    // Убеждаемся, что delta - целое число (int64)
    const delta = Math.round(params.delta);

    const response = await apiClient.post<UpdateBalanceResponse>(
      `/devices/${params.deviceId}/place/${params.placeId}/update`,
      { delta }
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
